<div class="col h-full page-background" [waiting]="loadingService.isLoading$(this) | async">
  @if (contractPublication) {
    <div class="col grow mx-32 mt-16">
      <icz-card>
        <div class="p-12">
          <div class="row-32">
            <div class="col grow">
              <div class="row">
                <icz-tag  [label]="'en.contractPublicationState.' + publicationTagState" [color]="publicationTagColor" class="mt-16"></icz-tag>
                <div class="row">
                  <icz-heading level="3" label="Smlouva"></icz-heading>
                  @if (contractPublication.contractId) {
                    <a class="heading-link-color"
                       iczLinkWithoutHref (click.stop)="openContractExternal()">
                      <icz-heading level="3" [label]="contractIdLinkHeaderText"></icz-heading>
                    </a>
                    <icz-icon size="small" svgIcon="open_modal"></icz-icon>
                  }
                </div>
              </div>
              <div class="col">
                <icz-label label="Protistrana" class="mb-8"></icz-label>
                @if (contractSubject) {
                  <icz-subject-detail-card
                    [subject]="contractSubject"
                    [showAllAttributes]="true"
                    [areAddressesReadonly]="true"
                    [allowSubjectEdit]="false"
                    [allowSubjectUnlink]="false"
                  ></icz-subject-detail-card>
                  @if (hasMultipleSubjects) {
                    <icz-button class="mt-8" [label]="contractSubjectsText()" (onAction)="openContractPublicationDetail(PublishContractConsignmentDialogMode.SUBJECTS_LIST)"></icz-button>
                  }
                }
              </div>
            </div>
            <div class="col grow">
              <div class="row button-collection">
                <icz-button-collection
                  size="large"
                  [groupButtons]="true"
                  [hideBorders]="true"
                  [buttons]="contractActionButtons"
                  (buttonClicked)="buttonClicked($event)"
                ></icz-button-collection>
              </div>
              <div class="grow col">
                <icz-label label="Údaje o smlouvě" class="my-16"></icz-label>
                <div class="row">
                  <div class="col icon-position">
                    <icz-icon svgIcon="smlouva"></icz-icon>
                  </div>
                  <div class="col">
                    @if(contractForInfo) {
                      <ng-container [ngTemplateOutlet]="contractInfo" [ngTemplateOutletContext]="{$implicit: contractForInfo}"></ng-container>
                    }
                    <a
                       iczLinkWithoutHref (click.stop)="openContractPublicationDetail(PublishContractConsignmentDialogMode.COMPONENTS_LIST)">
                      <span>{{ contractComponentsText() }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </icz-card>
    </div>
    <icz-section
      boxed noPadding class="relative"
      label="Přehled komunikace s registrem smluv"
      [expanded]="responsivityService.isLargeDesktop() === false"
    >
      <icz-table
        id="contract-publication-activities-table"
        tableTitle="Přehled komunikace s registrem smluv"
        [dataSource]="activitiesDatasource"
        [columnsData]="activitiesColumnData"
        [config]="activitiesTableConfig"
      >

        <icz-label notFoundLabel label="Žádné aktivity nebyly nalezeny"></icz-label>

        <ng-container *iczColumnTemplate="let row from [activitiesDatasource, activitiesColumnData]; id: 'initUserId'; withEllipsis: true">
          <span>{{ row.initUserId | findUserById | async }}</span>
        </ng-container>

        <ng-container *iczColumnTemplate="let row from [activitiesDatasource, activitiesColumnData]; id: 'operationType'; withEllipsis: true">
          <span>
            {{ ('en.contractPublicationType.' + row.operationType) | translate }}
            <a class="p-4 icz-body-1" iczLinkWithoutHref (click.stop)="openContractVersion(row)">
              ({{ 'náhled verze' | translate }})
            </a>
          </span>
        </ng-container>

        <ng-container *iczColumnTemplate="let row from [activitiesDatasource, activitiesColumnData]; id: 'contractVersionId'; withEllipsis: true">
          @if(row.contractVersionId) {
            <span>
              <a iczLinkWithoutHref (click.stop)="openContractExternal(row.contractVersionUrl)">
                {{ row.contractVersionId }}
              </a>
            </span>
          }
        </ng-container>

        <ng-container *iczColumnTemplate="let row from [activitiesDatasource, activitiesColumnData]; id: 'receivedDocumentRefNumber'; withEllipsis: true">
          @if(row.receivedDocumentRefNumber) {
            <span>
              <a iczLinkWithoutHref (click.stop)="openReceivedDocument(row)">
                {{ row.receivedDocumentRefNumber }}
              </a>
            </span>
          }
        </ng-container>

      </icz-table>
    </icz-section>
  }
</div>

<ng-template #contractInfo let-contract>
  <icz-label class="text-bold" [label]="contract.refNumber"></icz-label>
  <icz-label [label]="contract.subject"></icz-label>
  <icz-label [label]="('Datum uzavření smlouvy' | translate) + ': ' +  (contract.contractConfirmationDate | localizedDate)"></icz-label>
</ng-template>
